export default __webpack_public_path__ + "static/media/gadgets.e61c997b.jpeg";